import { createFileRoute } from '@tanstack/react-router';
import { OnlineCreatePage } from '@/pages/online-create.page';

export const Route = createFileRoute('/online/create')({
  component: OnlineCreatePage,
});
